import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import * as auth from "../../store/ducks/auth.duck";
import MFAForm from "../../components/MFAForm";

function TotpReminder() {
  const history = useHistory();
  const dispatch = useDispatch();
  const roleDesc = useSelector((state) => state.auth.roleDesc);
  const [showMFA, setShowMFA] = useState(false);

  const handleSetup = () => {
    setShowMFA(true);
  };

  const handleSkip = () => {
    dispatch(auth.actions.setMfaReminderSkipped(true));
    history.push("/dashboard");
  };

  const handleMFAClose = () => {
    // console.log("Closing MFA form");
    setShowMFA(false);
  };

  if (showMFA) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          padding: "30px",
        }}
      >
        <div
          style={{
            width: "650px",
            maxWidth: "100%",
          }}
        >
          <div
            className="kt-login__title"
            style={{
              marginBottom: 25,
              textAlign: "center",
            }}
          >
            <h3>Configure MFA</h3>
          </div>

          <MFAForm type={roleDesc} onCloseMFA={handleMFAClose} />
        </div>
      </div>
    );
  }
  return (
    <>
      <div className="kt-login__head"></div>

      <div className="kt-login__body">
        <div className="kt-login__form">
          <div className="kt-login__title" style={{ marginBottom: 35 }}>
            <h3>
              Configure Multi Factor
              <br />
              Authentication
            </h3>
          </div>

          <div className="form-group">
            <div className="alert alert-danger">
              <div className="alert-text">
                <i className="far fa-warning"></i> Confidential Information - Authorized access only.
              </div>
            </div>

            <div className="alert alert-info" style={{ marginBottom: 25 }}>
              <div className="alert-text">
                <strong>Multi factor authentication isn't set up</strong>
                <br />
                Your account is only protected by a password. Add a second verification step to help keep client information secure.
              </div>
            </div>

            <div style={{ marginBottom: 25 }}>
              <p style={{ marginBottom: 12 }}>Setup takes about 2 minutes. You can receive your verification codes by:</p>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 12,
                }}
              >
                <i
                  className="fas fa-mobile-alt"
                  style={{
                    width: 30,
                    fontSize: 16,
                    color: "#5867dd",
                  }}
                ></i>

                <span>
                  An authenticator app, e.g. Microsoft or Google
                  <br />
                  Authenticator
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <i
                  className="far fa-envelope"
                  style={{
                    width: 30,
                    fontSize: 16,
                    color: "#5867dd",
                  }}
                ></i>

                <span>Email, sent to the address on your account</span>
              </div>
            </div>

            <hr style={{ marginBottom: 25 }} />

            <div
              className="kt-login__actions"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Button
                variant="link"
                onClick={handleSkip}
                style={{
                  paddingLeft: 0,
                  color: "#6c6c6c",
                }}
              >
                Skip for now
              </Button>

              <Button
                variant="primary"
                onClick={handleSetup}
                style={{
                  minWidth: 100,
                }}
              >
                Set up now
              </Button>
            </div>

            <div
              style={{
                marginTop: 18,
                fontSize: 11,
                color: "#a1a1a1",
              }}
            >
              You'll be reminded again next time you sign in.
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TotpReminder;
